import {
  GET_CATEGORIES_SUCCESS,
  GET_SALON_LIST_SUCCESS,
  UNRATED_APPOINTMENTS_SUCCESS,
  SUBMIT_RATING_SUCCESS,
  GET_LOCATION_SUCCESS,
} from '../constants';

const initialState = {
  categories: [],
  salonList: [],
  locFound: 'fetching',
  unratedAppointments: [],
  location: '',
  fetchedUnratedAppointments: true,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CATEGORIES_SUCCESS:
      return { ...state, categories: action.data };
    case GET_SALON_LIST_SUCCESS:
      return { ...state, salonList: action.data };
    case UNRATED_APPOINTMENTS_SUCCESS:
      return {
        ...state,
        unratedAppointments: action.data,
      };
    case SUBMIT_RATING_SUCCESS:
      return {
        ...state,
        fetchedUnratedAppointments: false,
      };
    case GET_LOCATION_SUCCESS:
      return {
        ...state,
        location: action.data,
      };
    default:
      return state;
  }
};

export default reducer;
